'use client';

import React from 'react';

import classNames from 'classnames';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { RewardPool } from '@shared/api/types/rewardPools';

import RewardPoolCard from './RewardPoolCard/RewardPoolCard';

const RewardPoolsSlider = ({
  rewardPools,
  className,
}: {
  rewardPools: RewardPool[];
  className?: string;
}) => {
  return (
    <Swiper
      className={classNames(
        'pb-[2.25rem] xl:pb-10 -mx-4 max-md:px-4 md:-mx-2 line-swiper-pagination',
        className,
      )}
      data-qa="featured_pools"
      modules={[Pagination]}
      pagination={{
        enabled: true,
        clickable: true,
      }}
      slidesPerView="auto"
    >
      {rewardPools.map((rewardPool, i) => (
        <SwiperSlide
          key={i}
          className="select-none px-2 w-full md:w-1/2 lg:w-1/3 xl:w-1/4 h-auto max-md:first:pl-0 max-md:last:pr-0"
        >
          <RewardPoolCard className="h-full" rewardPool={rewardPool} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default RewardPoolsSlider;
